import React, { useRef, FunctionComponent, useState, useEffect } from "react";
import styles from "./AddOrganization.module.css";
import TextInput from "../../Components/TextInput/TextInput";

import { createOrganization } from "../../Services/organizations";

import { emailValidate, phoneValidate,gstValidate } from "../../Values/validatorsnew";
import Loading from "../../Components/Loading/Loading";
import { AiOutlineClose } from "react-icons/ai";
import Select from "react-select";
import { countryData,domainData ,organizationStatus} from "../../Values/constants";
import Label from "../../Components/Label";
import { themeColors } from "../../Components/theme";
import { connect, useDispatch } from "react-redux";
import { showSnackbarAction } from "../../Redux/actions";
import { googleAnalytics } from "../../Services/users";

type props = {
  history: any;
  theme:any;
  authToken?: any;
};
const AddOrganization: FunctionComponent<props> = ({ history,theme,authToken }) => {
  const dispatcher = useDispatch();
  const [load, setLoad] = useState(false);
  const [state, setState] = useState("");

  const [country, setCountry] = useState("India");
  const organizationNameRef: any = useRef();
  const mobileNumberRef: any = useRef();
  const emailRef: any = useRef();
  const cityRef: any = useRef();
  const addressRef: any = useRef();
  const pincodeRef: any = useRef();
  const adminFirstNameRef: any = useRef();
  const adminLastNameRef: any = useRef();
  const adminContactNumberRef: any = useRef();
  const adminEmailRef: any = useRef();
  const employeesRef: any = useRef();
  const [businessDomain, setBusinessDomain]:any = useState("");
  const costPerLicenseRef: any = useRef();
  const gracePeriodRef: any = useRef();
  const gstNumberRef: any = useRef();
  const validTillRef: any = useRef();
  const validFromRef: any = useRef();
  const [shiftActiveStatus, setShiftActiveStatus]:any = useState("");
  const [organizationActiveStatus, setOrganizationActiveStatus]:any = useState("");

  useEffect(() => {
    window.onbeforeunload = function () {
      return "Are you really want to perform the action?";
    };
  }, []);

  const create = (e:any) => {
    e.preventDefault();
    setLoad(true);
    if(!businessDomain.value){
      dispatcher(
        showSnackbarAction(
          "Please select the organization domain",
          "error"
        )
      );
      setLoad(false);
      return
    }
    if(!gracePeriodRef.current.value){
      dispatcher(
        showSnackbarAction(
          "Please enter grace period",
          "error"
        )               
      );
      setLoad(false);
      return
    }
    if(!costPerLicenseRef.current.value){
      dispatcher(
        showSnackbarAction(
          "Please enter cost of license",
          "error"
        )
      );
      setLoad(false);
      return
    }
    if(!validFromRef.current.value){
      dispatcher(
        showSnackbarAction(
          "Please enter valid from date",
          "error"
        )
      );
      setLoad(false);
      return
    }
    if(!validTillRef.current.value){
      dispatcher(
        showSnackbarAction(
          "Please enter Valid Till date",
          "error"
        )
      );
      setLoad(false);
      return
    }   
    if(!shiftActiveStatus.value){
      dispatcher(
        showSnackbarAction(
          "Please select shift active status",
          "error"
        )
      );
      setLoad(false);
      return
    }
    if(!organizationActiveStatus.value){
      dispatcher(
        showSnackbarAction(
          "Please select organization active status",
          "error"
        )
      );
      setLoad(false);
      return
    }
    
    createOrganization(
      organizationNameRef.current?.value,
      mobileNumberRef.current?.value,
      emailRef.current?.value,
      addressRef.current?.value,
      country,
      state,
      cityRef.current?.value,
      pincodeRef.current?.value,
      adminFirstNameRef.current?.value,
      adminLastNameRef.current?.value,
      adminContactNumberRef.current?.value,
      adminEmailRef.current?.value,
      employeesRef.current?.value,
      businessDomain.value,
      history,
      dispatcher,
      window,
      (data: boolean) => setLoad(data),
      costPerLicenseRef.current?.value,
      gracePeriodRef.current?.value,
      validFromRef.current?.value,
      validTillRef.current?.value,
      gstNumberRef.current?.value,
      shiftActiveStatus?.value === 'True'?true:false,
      organizationActiveStatus?.value === 'True'?true:false,
      authToken,
    );
  };

  const choice = () => {
    let data = countryData[country].map((item: any) => ({
      value: item,
      label: item,
    }));

    return data;
  };

  const countryChoice = () => {
    let data = Object.keys(countryData).map((item: any, index: number) => ({
      value: item,
      label: item,
    }));

    return data;
  };


  const domainChoice = () => {
    let data = domainData.map((item: any, index: number) => ({
      value: item,
      label: item,
    }));

    return data;
  };

  const organizationChoice = () => {
    let data = organizationStatus.map((item: any, index: number) => ({
      value: item,
      label: item,
    }));

    return data;
  };

  const containerStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
  const cardContainerStyles = { backgroundColor: theme ? themeColors.cardBackgroundColor : themeColors.cardBackgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
  const selectInputContainerStyles = { width: "140px", marginRight: "5px" };
  useEffect(()=>{
    googleAnalytics('Add_Organization_Screen')
  },[])
  return (
    // <div className={styles.parent}>
    //   {load === true && <Loading />}
    //   <div className={styles.child}>
    //     <div className={styles.headerView}>
    //       <p className={styles.heading}> Add Organization Details</p>
    //       <AiOutlineClose
    //         className={styles.closeIcon}
    //         size={25}
    //         onClick={() => history.replace("/")}
    //       />
    //     </div>
    //     <div className={styles.title}>
    //       <p className={styles.one}>Organization Name</p>
    //       <p className={styles.two}>*</p>
    //     </div>
    //     <div className={styles.box}>
    //       <TextInput
    //         title={"Enter Name"}
    //         style={{ backgroundColor: "#fff" }}
    //         ref={organizationNameRef}
    //       ></TextInput>
    //     </div>

    //     <div className={styles.box2}>
    //       <div className={styles.divide}>
    //         <div className={styles.title}>
    //           <p className={styles.one}>Mobile Number</p>
    //           <p className={styles.two}>*</p>
    //         </div>
    //         <div>
    //           <TextInput
    //             title={"Enter Number"}
    //             style={{ backgroundColor: "#fff" }}
    //             ref={mobileNumberRef}
    //             validator={phoneValidate}
    //             length={true}
    //           />
    //         </div>
    //       </div>

    //       <div className={styles.divide}>
    //         <div className={styles.title}>
    //           <p className={styles.one}>Email Id</p>
    //           <p className={styles.two}>*</p>
    //         </div>
    //         <div>
    //           <TextInput
    //             title={"Enter Email"}
    //             style={{ backgroundColor: "#fff" }}
    //             ref={emailRef}
    //             validator={emailValidate}
    //           />
    //         </div>
    //       </div>
    //     </div>

    //     <div style={{ marginTop: "22px" }} className={styles.title}>
    //       <p className={styles.one}>Address</p>
    //       <p className={styles.two}>*</p>
    //     </div>
    //     <div className={styles.box}>
    //       <TextInput
    //         title={"Enter Address"}
    //         style={{ backgroundColor: "#fff" }}
    //         ref={addressRef}
    //       />
    //     </div>

    //     <div className={styles.box2}>
    //       <div className={styles.divide}>
    //         <div className={styles.title}>
    //           <p className={styles.one}>COUNTRY</p>
    //           <p className={styles.two}>*</p>
    //         </div>
    //         <div>
    //           <Select
    //             options={countryChoice()}
    //             onChange={(data) => {
    //               setCountry(data?.label);
    //             }}
    //             isSearchable={true}
    //           />
    //         </div>
    //       </div>

    //       <div className={styles.divide}>
    //         <div className={styles.title} style={{ marginBottom: "3%" }}>
    //           <p className={styles.one}>STATE</p>
    //           <p className={styles.two}>*</p>
    //         </div>
    //         <div>
    //           <Select
    //             options={choice()}
    //             onChange={(data) => {
    //               setState(data?.label);
    //             }}
    //             isSearchable={true}
    //           />
    //         </div>
    //       </div>
    //     </div>

    //     <div className={styles.box2}>
    //       <div className={styles.divide}>
    //         <div className={styles.title}>
    //           <p className={styles.one}>CITY</p>
    //           <p className={styles.two}>*</p>
    //         </div>
    //         <div>
    //           <TextInput
    //             title={"Enter City"}
    //             style={{ backgroundColor: "#fff" }}
    //             ref={cityRef}
    //           />
    //         </div>
    //       </div>

    //       <div className={styles.divide}>
    //         <div className={styles.title}>
    //           <p className={styles.one}>PINCODE</p>
    //           <p className={styles.two}>*</p>
    //         </div>
    //         <div>
    //           <TextInput
    //             title={"Enter Pincode"}
    //             style={{ backgroundColor: "#fff" }}
    //             ref={pincodeRef}
    //           />
    //         </div>
    //       </div>
    //     </div>

    //     <div className={styles.box2}>
    //       <div className={styles.divide}>
    //         <div className={styles.title}>
    //           <p className={styles.one}>ADMIN FIRST NAME</p>
    //           <p className={styles.two}>*</p>
    //         </div>
    //         <div>
    //           <TextInput
    //             title={"Enter First Name"}
    //             style={{ backgroundColor: "#fff" }}
    //             ref={adminFirstNameRef}
    //           />
    //         </div>
    //       </div>

    //       <div className={styles.divide}>
    //         <div className={styles.title}>
    //           <p className={styles.one}>ADMIN LAST NAME</p>
    //           <p className={styles.two}>*</p>
    //         </div>
    //         <div>
    //           <TextInput
    //             title={"Enter Last Name"}
    //             style={{ backgroundColor: "#fff" }}
    //             ref={adminLastNameRef}
    //           />
    //         </div>
    //       </div>
    //     </div>

    //     <div className={styles.box2}>
    //       <div className={styles.divide}>
    //         <div className={styles.title}>
    //           <p className={styles.one}>ADMIN CONTACT NUMBER</p>
    //           <p className={styles.two}>*</p>
    //         </div>
    //         <div>
    //           <TextInput
    //             title={"Enter Number"}
    //             style={{ backgroundColor: "#fff" }}
    //             ref={adminContactNumberRef}
    //             validator={phoneValidate}
    //           />
    //         </div>
    //       </div>

    //       <div className={styles.divide}>
    //         <div className={styles.title}>
    //           <p className={styles.one}>ADMIN EMAIL ID</p>
    //           <p className={styles.two}>*</p>
    //         </div>
    //         <div>
    //           <TextInput
    //             title={"Enter Email"}
    //             style={{ backgroundColor: "#fff" }}
    //             ref={adminEmailRef}
    //             validator={emailValidate}
    //           />
    //         </div>
    //       </div>
    //     </div>

    //     <div className={styles.box2}>
    //       <div className={styles.divide}>
    //         <div className={styles.title}>
    //           <p className={styles.one}>NUMBER OF EMPLOYEES</p>
    //           <p className={styles.two}>*</p>
    //         </div>
    //         <div>
    //           <TextInput
    //             title={"Enter Number Of Employees"}
    //             style={{ backgroundColor: "#fff" }}
    //             ref={employeesRef}
    //           />
    //         </div>
    //       </div>
    //     </div>

    //     <button className={styles.button} onClick={() => create()}>
    //       Submit
    //     </button>
    //   </div>
    // </div>
    <div className={styles.parent} style={containerStyles}>
      {load === true && <Loading />}
      <div
        // className={styles.headerView}
        className="d-flex flex-row w-100 px-4 pt-4"
      >
        <h5
        // className={styles.heading}
        > Add Organization Details</h5>
        <AiOutlineClose
          className={styles.closeIcon}
          size={25}
          onClick={() => history.replace("/")}
        />
      </div>
      <div
        // className={styles.child}
        className="w-100 d-flex flex-column gap-2 px-4"
      >
        <form className="card p-4 shadow rounded mt-2" style={cardContainerStyles}>

          <div className={styles.box2}>
            <div className={styles.divide}>
              <Label label="Organization Name" required={true} />
              <div className={styles.inputContainer}>
                <TextInput
                  title={"Enter Name"}
                  style={{ backgroundColor: "#fff" }}
                  ref={organizationNameRef}
                ></TextInput>
              </div>
            </div>
            <div className={styles.divide}>
              <Label label="Mobile Number" required={true} />
              <div className={styles.inputContainer}>
                <TextInput
                  title={"Enter Number"}
                  style={{ backgroundColor: "#fff" }}
                  ref={mobileNumberRef}
                  validator={phoneValidate}
                  length={true}
                />
              </div>
            </div>

            <div className={styles.divide}>
              <Label label="Email Id" required={true} />
              <div className={styles.inputContainer}>
                <TextInput
                  title={"Enter Email"}
                  style={{ backgroundColor: "#fff" }}
                  ref={emailRef}
                  validator={emailValidate}
                />
              </div>
            </div>
          </div>

          <div className={styles.box2}>
            <div className={styles.divide}>
              <Label label="Address" required={true} />
              <div className={styles.inputContainer}>
                <TextInput
                  title={"Enter Address"}
                  style={{ backgroundColor: "#fff" }}
                  ref={addressRef}
                />
              </div>
            </div>
            <div className={styles.divide}>
              <Label label="Country" required={true} />
              <div style={{ color: "#000", ...selectInputContainerStyles }} >
                <Select
                  options={countryChoice()}
                  onChange={(data) => {
                    setCountry(data?.label);
                  }}
                  isSearchable={true}
                />
              </div>
            </div>

            <div className={styles.divide}>
              <Label label="State" required={true} />
              <div style={{ color: "#000", ...selectInputContainerStyles }} >
                <Select
                  options={choice()}
                  onChange={(data) => {
                    setState(data?.label);
                  }}
                  isSearchable={true}
                />
              </div>
            </div>
          </div>

          <div className={styles.box2}>
            <div className={styles.divide}>
              <Label label="City" required={true} />
              <div className={styles.inputContainer}>
                <TextInput
                  title={"Enter City"}
                  style={{ backgroundColor: "#fff" }}
                  ref={cityRef}
                />
              </div>
            </div>

            <div className={styles.divide}>
              <Label label="Pin Code" required={true} />
              <div className={styles.inputContainer}>
                <TextInput
                  title={"Enter Pincode"}
                  style={{ backgroundColor: "#fff" }}
                  ref={pincodeRef}
                />
              </div>
            </div>
            <div className={styles.divide}>
              <Label label="Admin First Name" required={true} />
              <div className={styles.inputContainer}>
                <TextInput
                  title={"Enter First Name"}
                  style={{ backgroundColor: "#fff" }}
                  ref={adminFirstNameRef}
                />
              </div>
            </div>
          </div>
          
          <div className={styles.box2}>

            <div className={styles.divide}>
              <Label label="Admin Last Name" required={true} />
              <div className={styles.inputContainer}>
                <TextInput
                  title={"Enter Last Name"}
                  style={{ backgroundColor: "#fff" }}
                  ref={adminLastNameRef}
                />
              </div>
            </div>
            <div className={styles.divide}>
              <Label label="Admin Contact Number" required={true} />
              <div className={styles.inputContainer}>
                <TextInput
                  title={"Enter Number"}
                  style={{ backgroundColor: "#fff" }}
                  ref={adminContactNumberRef}
                  validator={phoneValidate}
                />
              </div>
            </div>

            <div className={styles.divide}>
              <Label label="Admin Email Id" required={true} />
              <div className={styles.inputContainer}>
                <TextInput
                  title={"Enter Email"}
                  style={{ backgroundColor: "#fff" }}
                  ref={adminEmailRef}
                  validator={emailValidate}
                />
              </div>
            </div>
          </div>

          <div className={styles.box2}>
            <div className={styles.divide}>
              <Label label="Number of Employees" required={true} />
              <div className={styles.inputContainer}>
                <TextInput
                  title={"Enter Number Of Employees"}
                  style={{ backgroundColor: "#fff" }}
                  ref={employeesRef}
                />
              </div>
            </div>
            <div className={styles.divide}>
              <Label label="Cost Per License" required={true} />
              <div className={styles.inputContainer}>
                <TextInput
                type={"number"}
                  title={"Enter Cost Per License"}
                  style={{ backgroundColor: "#fff" }}
                  ref={costPerLicenseRef}
                />
              </div>
            </div>

            
            <div className={styles.divide}>
              <Label label="Domain" required={true} />
              <div style={{ color: "#000", ...selectInputContainerStyles }} >
                <Select
                  options={domainChoice()}
                  onChange={(data) => {
                    setBusinessDomain(data);
                  }}
                  isSearchable={true}
                />
              </div>
            </div>
          </div>
          
          <div className={styles.box2}>
            <div className={styles.divide}>
              <Label label="Grace Period" required={true} />
              <div className={styles.inputContainer}>
                <TextInput
                type={"number"}
                  title={"Enter Grace Period"}
                  style={{ backgroundColor: "#fff" }}
                  ref={gracePeriodRef}
                ></TextInput>
              </div>
            </div>
            <div className={styles.divide}>
              <Label label="Valid From" required={true} />
              <div className={styles.inputContainer}>
                <TextInput
                type={"date"}
                  title={"Valid From"}
                  style={{ backgroundColor: "#fff" }}
                  ref={validFromRef}
                />
              </div>
            </div>

            <div className={styles.divide}>
              <Label label="Valid Till" required={true} />
              <div className={styles.inputContainer}>
                <TextInput
                type={"date"}
                  title={"Valid Till"}
                  style={{ backgroundColor: "#fff" }}
                  ref={validTillRef}
                />
              </div>
            </div>
          </div>
          <div className={styles.box2}>
          <div className={styles.divide}>
              <Label label="GST Number" required={false} />
              <div className={styles.inputContainer}>
                <TextInput
                type={"text"}
                  title={"Enter GST Number"}
                  style={{ backgroundColor: "#fff" }}
                  ref={gstNumberRef}
                  validator={gstValidate}
                  // validator={emailValidate}
                />
              </div>
            </div>
            <div className={styles.divide}>
              <Label label="Shift Active Status" required={true} />
              <div style={{ color: "#000", ...selectInputContainerStyles }} >
                <Select
                  options={organizationChoice()}
                  onChange={(data) => {
                    setShiftActiveStatus(data);
                  }}
                  isSearchable={true}
                />
              </div>
            </div>
            <div className={styles.divide}>
              <Label label="Organization Active Status" required={true} />
              <div style={{ color: "#000", ...selectInputContainerStyles }} >
                <Select
                  options={organizationChoice()}
                  onChange={(data) => {
                    setOrganizationActiveStatus(data);
                  }}
                  isSearchable={true}
                />
              </div>
            </div>
            </div>
          <button className={styles.button} onClick={(e:any) => create(e)}>
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    theme: state.theme.isLightMode,
    authToken: state.user.authToken
  };
};

export default connect(mapStateToProps)(AddOrganization);
